import callApi from "../api";
import { BASE_URL_FLORAHUB } from "../Redux/App/action";

export const INCREASE_QUANTITY = "INCREASE_QUANTITY";
export const DECREASE_QUANTITY = "DECREASE_QUANTITY";
export const GET_ALL_PRODUCT = "GET_ALL_PRODUCT";
export const SEND_CART_PRODUCT = "SEND_CART_PRODUCT";
export const DELETE_CART = "DELETE_CART";
export const RESET_QUANTITY = "RESET_QUANTITY";
export const STOP_LOADING = "STOP_LOADING";
export const START_LOADING = "START_LOADING";
export const ERROR = "ERROR";

export const fetchProducts = () => {
  return async (dispatch) => {
    try {
      dispatch(startLoading());

      const res = await callApi(
        `${BASE_URL_FLORAHUB}/inventory/api/v1/cart`,
        "GET",
        null,
        null
      );
      dispatch(GetAllProduct(res.data.payload));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dispatch(stopLoading());
    }
  };
};

export const actSendProductsRequest = (data, isNavigate = false) => {
  return async (dispatch) => {
    try {
      const res = await callApi(
        `${BASE_URL_FLORAHUB}/inventory/api/v1/cart`,
        "POST",
        data,
        null
      );
      console.log(res.data.payload);

      dispatch(startLoading());
      dispatch(SendCartProduct(res.data));
      dispatch(stopLoading());
    } catch (error) {
      dispatch(handleErrorAction());
      dispatch(stopLoading());
    }
  };
};

export const startLoading = () => ({
  type: START_LOADING,
});

export const stopLoading = () => ({
  type: STOP_LOADING,
});

export const handleErrorAction = () => ({
  type: ERROR,
});

/*GET_ALL_PRODUCT*/
export function GetAllProduct(products) {
  return {
    type: GET_ALL_PRODUCT,
    payload: products,
  };
}

/*SEND_CART_PRODUCT*/
export function SendCartProduct(payload) {
  actSendProductsRequest(payload);
  return {
    type: SEND_CART_PRODUCT,
    payload,
  };
}

export function DeleteCart(payload) {
  return {
    type: DELETE_CART,
    payload,
  };
}

export function incrementQuantity(productDetail) {
  return {
    type: INCREASE_QUANTITY,
    payload: productDetail,
  };
}

export const decrementQuantity = (productDetail) => ({
  type: DECREASE_QUANTITY,
  payload: productDetail,
});
